import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import axios from "../../axios/axios";
import moment from "moment";
import { Button } from "react-bootstrap";
import { CSVLink } from "react-csv";
import "./reports.css";
import { DATE_TIME_FORMAT } from "../../constants/constants";
import { adminConfig } from "../../utils/adminConfig";

export default function ClientWiseMemberReport() {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalRedeemCount, setTotalRedeemCount] = useState(0);
   const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [members, setMembers] = useState([]);
  const [pagination, setPagination] = useState({
    limit: 10,
    page: 1,
    totalPage: 0,
    totalRows: 0,
  });
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [csvData, setCsvData] = useState([]);

  const columns = [
    {
      name: "Name",
      selector: (row) => row?.clientData?.name,
      width: "300px",
    },
    {
      name: "Email",
      selector: (row) => row?.clientData?.email,
      width: "350px",
    },
    {
      name: "Count",
      selector: (row) => row?.memberCount,
      width: "150px",
    },
  ];

  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
      },
    },
    headCells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
        fontSize: "17px",
        color: "#004aad",
      },
    },
    cells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
        fontSize: "16px",
      },
    },
  };

  useEffect(() => {
    getAllMembersCertificateRedeem();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, search , startDate, endDate]);

  const getAllMembersCertificateRedeem = () => {
    setLoading(true);
    axios
      .get(
        `/all-users-client-wise-count?source=tvi&page=${page}&limit=${limit}&search=${search}&startDate=${startDate}&endDate=${endDate}`,
        adminConfig()
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          setMembers(res.data.data);
          setPagination(res.data.pagination);
          setTotalRedeemCount(res.data.totalMember);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const handlePerRowsChange = (newPerPage) => {
    setLimit(newPerPage);
    setPage(1);
  };

  const changePage = (newPage) => {
    setPage(newPage);
  };

  const exportCSV = () => {
    setLoading(true);
    axios
      .get(
        `/all-users-client-wise-count?source=tvi&page=1&limit=${pagination.totalRows}&search=${search}&startDate=${startDate}&endDate=${endDate}`,
        adminConfig()
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          const csvData = res.data.data.map((member) => ({
            Name: member?.clientData?.name,
            Email: member?.clientData?.email,
            Count: member?.memberCount,
          }));
          let dd = [
            ...csvData,
            {
              Name: "Total",
              Email: "",
              Count: res.data.totalMember,
            },
          ]
          setCsvData(dd);
          setTimeout(() => {
            document.getElementById("csv-download-link").click();

            setLoading(false);
          }, 2000);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const csvHeaders = [
    { label: "Name", key: "Name" },
    { label: "Email", key: "Email" },
    { label: "Member Count", key: "Count" },
  ];

  return (
    <LoadingOverlay active={loading} spinner text="Loading ...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <div className="user_added">
                <div className="ar_count_card d-flex">
                  <h3>Client Members Count</h3>
                 
                </div>
               <div>
                  <div className="row">
                    <div className="col-md-4">
                      <label>Name & Email</label>
                      <input
                        placeholder="Type name or email"
                        type="text"
                        id="form1"
                        className="form-control"
                        onChange={(e) => {
                          setQuery(e.target.value);
                          setTimeout(() => {

                            setSearch(e.target.value);
                          }, 1000)
                        }}
                      />

                    </div>
                    <div className="col-md-3">
                      <label>Start Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                      />
                    </div>
                    <div className="col-md-3">
                      <label>End Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                      />
                    </div>
                    <div className="col-md-1">
                      <Button
                        className="btn btn-dark mt-4"
                        variant="default"
                        onClick={() => {
                          setPage(1);
                          setQuery("");
                          setSearch("");
                          setStartDate("");
                          setEndDate("");
                        }}
                      >
                        Clear
                      </Button>
                    </div>
                  </div>


                  <div className="row">
                    <div className="col-md-12 form-group text-right">
                      <Button
                        className="btn btn-primary search_button "
                        onClick={exportCSV}
                      >
                        Export CSV
                      </Button>
                      <CSVLink
                        data={csvData}
                        headers={csvHeaders}
                        filename={(startDate ? `corporate_members_${startDate}_${endDate}.csv` : `corporate_members_${moment().format("MM-DD-YYYY")}.csv`)}
                        className="hidden"
                        id="csv-download-link"
                        target="_blank"
                      />
                    </div>
                  </div>
                </div>

                <DataTable
                  columns={columns}
                  data={members}
                  pagination
                  striped
                  responsive
                  customStyles={customStyles}
                  subHeaderAlign="right"
                  subHeaderWrap
                  paginationDefaultPage={page}
                  paginationServer
                  paginationTotalRows={pagination.totalRows}
                  paginationPerPage={limit}
                  paginationRowsPerPageOptions={[10, 15, 20, 40]}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={changePage}
                  className={members.length === 1 ? "search_state" : ""}
                  progressComponent={<CustomLoader />}
                  noDataComponent={<EmptyDataLoader />}
                  fixedHeaderScrollHeight="500px"
                  fixedHeader
                />
                 {/* Grand Total Row */}
                <div className="certificate_fixed_total_count">
                  <div ></div>
                  <div>Total Member : </div>
                  <div>{totalRedeemCount}</div>
                </div>
                {/* End Grand Total Row */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
}

const CustomLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>Loading...</div>
  </div>
);
const EmptyDataLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>No data found...</div>
  </div>
);
